// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".scanner-container #startButton,\n.scanner-container #resetButton,\n.scanner-container #sourceSelectPanel {\n  display: none !important;\n}\n.scanner-container #video {\n  margin: 0 auto;\n  display: block;\n}", ""]);
// Exports
module.exports = exports;
